import React, { useState, useEffect } from 'react';
import { Introduction } from './styled';
import { Typography, Icon, ReactIcon, Button, Image, SearchField } from '../../components';
import { GeneralContext } from '../../App';
import * as Papa from 'papaparse';
import { Link } from 'react-router-dom';

const loadImages = require.context('../../assets/images/podcast/zorgprofessionals', true);

export default function PodcastZorgprofessionals(props) {
    const { hasPhone, hasTablet } = React.useContext(GeneralContext);

    const [ episodes, setEpisodes ] = useState([]);
    const [ filteredEpisodes, setFilteredEpisodes ] = useState([]);

    const parsePodcastCsv = (data, columns) => {
        let dataRows = data.data;

        let newEpisodes = []
        for (let i = 1; i < dataRows.length; i++) {
            let row = dataRows[i];
            let dataObj = {}
            for (let j = 0; j < row.length; j++) {
                dataObj[columns[j]] = row[j];
            }
            newEpisodes.push(dataObj);
        }

        newEpisodes = newEpisodes.filter(e => e.type === 'zorgprofessionals')

        setEpisodes(newEpisodes);
        setFilteredEpisodes(newEpisodes);
    }

    useEffect(() => {
        if (episodes.length === 0) {
            fetch('../podcast.csv')
                .then( response => response.text() )
                .then( responseText => {
                    const data = Papa.parse(responseText);
                    
                    const columns = data['data'][0];
                    parsePodcastCsv(data, columns);
                })
        }
    }, [episodes]);

    return (
        <div>
            <Introduction>
                <Typography type='h1' style={{ color: '#92320F', margin: '0 0 2vw 0' }}>Borstvoedingsbabbel voor zorgprofessionals</Typography>
                <Typography style={{ width: hasPhone ? '80%' : '50%' }}>In de podcast <em>Borstvoedingsbabbel voor zorgprofessionals</em> van NOLIA BabyFeeding verbinden we alle partners in de geboortezorg
                    en creëren we één rode draad in de borstvoedingszorg. Met eerlijke gesprekken, praktijkvoorbeelden en frisse inzichten ontdek je hoe
                    jij - in jouw rol - kunt bijdragen aan een positief, consistent en toekomstbestendig borstvoedingsklimaat.
                </Typography>
                <div style={{ display: 'flex', gap: '5vw', margin: '3vw 0 0 0' }}>
                    <div style={{ display: 'flex', gap: '1vw', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => window.open(`https://${episodes[0]['algemeenspotify']}`, '_blank')}>
                        <Icon 
                            name='luidspreker' 
                            fill='white'
                            circleFill='#145F68'
                            hoverCircleFill='red'
                            width={hasPhone ? '8vw' : '2vw'}
                        />
                        <Typography style={{ margin: '0.5vw 0 0 0'}}>BELUISTER ZE HIER</Typography>
                    </div>
                    <div style={{ display: 'flex', gap: '1vw', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => window.open('https://www.youtube.com/playlist?list=PL00RmtZ14m0_YxPaWbocYsanFlQ0jAq3s', '_blank')}>
                        <ReactIcon name='youtube' circleFill='#145F68' noHover={true} noLink={true}/>
                        <Typography style={{ margin: '0.5vw 0 0 0'}}>BEKIJK ZE HIER</Typography>
                    </div>
                </div>
            </Introduction>
            <div style={{ display: 'flex', padding: '5vw 0', textAlign: 'center', width: '100%', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                <Typography type='h2' style={{ color: '#ECB991' }}>Alle afleveringen voor zorgprofessionals</Typography>
                <div style={{ margin: hasPhone ? '7vw 0' : hasTablet ? '5vw 0' : '2vw 0'}}>
                    <Typography>Ben je op zoek naar een specifieke aflevering?</Typography>
                    <Typography>Gebruik dan deze zoekbalk:</Typography>
                    <SearchField 
                        placeholder='zoeken in de podcasts'
                        items={episodes}
                        property='naam'
                        parentFunc={(newEpisodes) => { setFilteredEpisodes(newEpisodes) }}
                    />
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', padding: hasPhone ? '0 5vw' : hasTablet ? '0 12vw' : '0 13vw', columnGap: hasPhone ? '13vw' : hasTablet ? '7vw' : '5vw', rowGap: hasPhone ? '5vw' : hasTablet ? '3vw' : '2vw' }}>
                    {filteredEpisodes.length > 0 && filteredEpisodes.map((e, i) => {
                        return (
                            <Link style={{ maxWidth: hasPhone ? '35vw' : '20vw', cursor: 'pointer', textDecoration: 'none' }} to={`/podcast/zorgprofessionals/${e.nummer}`} key={e.nummer} >
                                <Image src={loadImages(`./zp-s1-${e.nummer}.png`)} style={{ width: hasPhone ? '35vw' : '20vw', height: hasPhone ? '35vw' : '20vw' }} />
                                <Typography type='h2' style={{ margin: '1vw 0 1vw 0', fontSize: hasPhone ? '1em' : hasTablet ? '1.3em' : '1.3em', color: '#BE6842'}}>
                                    #{e.nummer} {e.naam}
                                </Typography>
                            </Link>
                        )
                    })}
                </div>
            </div>
            <div style={{ display: 'flex', backgroundColor: 'white', flexDirection: 'column', alignItems: 'center', padding: '5vw 0'}}>
                <Typography type='h2' style={{ color: '#BB6848', margin: hasPhone ? '0 0 5vw 0' : '0 0 2vw 0', maxWidth: '80vw' }}>Nieuwsgierig naar de nieuwe standaard in borstvoedingszorg?</Typography>
                <Typography type='caps' style={{ color: '#B2522D', margin: hasPhone ? '0 0 5vw 0' : '0 0 2vw 0', maxWidth: '80vw' }}>DOWNLOAD HIER GRATIS ONZE GIDS VOOR PROFESSIONALS</Typography>
                <Button 
                    onClick={() => window.open('https://babyfeeding.nl/opt/gids-voor-professionals', '_blank')}
                    text='YES, DEZE WIL IK!'
                />
            </div>
        </div>
    )
}